import { render, staticRenderFns } from "./PurchaseRequisitionItems.vue?vue&type=template&id=5a68e4b0&scoped=true&"
import script from "./PurchaseRequisitionItems.vue?vue&type=script&lang=ts&"
export * from "./PurchaseRequisitionItems.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseRequisitionItems.vue?vue&type=style&index=0&id=5a68e4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a68e4b0",
  null
  
)

export default component.exports